module.exports = __webpack_public_path__ + "static/media/home-image-3.f4e9aabc.jpg";